module.exports = __webpack_public_path__ + "static/media/sign-up-form.cf3c0b13.jpg";